import React, { Component } from 'react';
import classNames from 'classnames';
import Icon from "@scentregroup/ui/components/icon";
import { DateTime } from '../../helpers/date-helpers';
import { formatDay, formatDayNumber, formatTime, formatMonth } from '../../helpers/date-format-helpers';
import { filterExpiredOccurrence } from '../../helpers/filter-expired-occurance';
import { occurrencesType } from './../../types';
import style from './index.module.scss';
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";

class ListEventTimes extends Component {
  constructor(props) {
    super(props);
    this.toggleExpanded = this.toggleExpanded.bind(this);
    this.state = {
      expanded: false,
      filteredOccurrences: filterExpiredOccurrence(this.props.occurrences)
    };
  }

  toggleExpanded() {
    this.setState({
      expanded: !this.state.expanded
    });
  }

  listEventTimes(list, timeZone) {
    return list.map(occurrence => {
      const startAt = DateTime.fromISO(occurrence.startAt, {
        timeZone
      });
      const endAt = DateTime.fromISO(occurrence.endAt, {
        timeZone
      });
      return /*#__PURE__*/_jsxs("li", {
        className: classNames(style.occurrence),
        children: [/*#__PURE__*/_jsxs("span", {
          className: classNames(style.hiddenMobile, style.occurrenceDay),
          children: [formatDay(startAt), ' ']
        }), /*#__PURE__*/_jsxs("span", {
          className: classNames(style.occurrenceDate),
          children: [formatDayNumber(startAt), " ", formatMonth(startAt), ' ']
        }), /*#__PURE__*/_jsxs("span", {
          className: classNames(style.occurrenceTime),
          children: [formatTime(startAt), ' - ', formatTime(endAt), ' ']
        })]
      }, occurrence.startAt);
    });
  }

  render() {
    const ITEMS_SHOWN = 5;
    const {
      filteredOccurrences: {
        times,
        timeZone
      }
    } = this.state;
    const list = this.state.expanded ? times : times.slice(0, ITEMS_SHOWN);

    if (times.length === 0) {
      return /*#__PURE__*/_jsx("div", {
        children: "No occurrences or past event"
      });
    }

    if (times.length > ITEMS_SHOWN) {
      return /*#__PURE__*/_jsxs("ul", {
        className: classNames(style.occurrenceTable),
        children: [this.listEventTimes(list, timeZone), /*#__PURE__*/_jsx("li", {
          className: classNames(style.occurrence),
          children: /*#__PURE__*/_jsxs("button", {
            className: classNames(style.showMore),
            onClick: this.toggleExpanded,
            children: ["Show ", this.state.expanded ? 'less' : 'more', " dates", /*#__PURE__*/_jsx(Icon, {
              type: this.state.expanded ? 'chevron-up' : 'chevron-down',
              className: style.carrot
            })]
          })
        })]
      });
    }

    return /*#__PURE__*/_jsx("ul", {
      className: classNames(style.occurrenceTable),
      children: this.listEventTimes(list, timeZone)
    });
  }

}

export default ListEventTimes;